<template>
  <v-container>

   
      <v-card max-width="695px" class="mx-auto mt-10">
          <v-card-title>
              <span v-if="!needEmail">Do you already have an email address?</span>           
          <!-- Lien pour ouvrir le modal -->
          <a 
            v-if="!needEmail" 
            href="javascript:void(0);" 
            class="no-underline bold responsive-spacing"
            @click="dialog = true"
          >
            Add now
          </a>
        </v-card-title>
          <!-- Dialog pour ajouter l'email -->
          <v-dialog v-model="dialog" max-width="500px">
              <v-card class="mx-auto" elevation="1">
                  <v-card-title class="py-5">
                      Securely access your tax form
                      <v-img
                          src="/logo.png"     
                          alt="Logo"
                          class="logo"
                      />
                      <h1>Please enter your email address so we can send you an access code.</h1>
                      <h2>Don't worry, we won't share your email with anyone.</h2>
                      <h3>Having an email address will also allow us to send you an access code in case you forget your password.</h3>
                  </v-card-title>

                  <v-card-text>
                      <v-card-title>
                          <span v-if="!needEmail" class="text-subtitle-2 font-weight-black mb-1">
                              Enter your email address
                          </span>
                          <span v-else class="text-subtitle-2 font-weight-black mb-1">
                              Enter your Access Code
                          </span>
                      </v-card-title>

                      <v-text-field
                          v-if="!needEmail"
                          v-model="email"
                          label="Enter email here"
                          variant="outlined"
                          single-line
                          type="email"
                      ></v-text-field>

                      <v-btn
                          v-if="!needEmail"
                          :loading="isLoadingAdd" 
                          :disabled="isLoadingAdd"
                          class="text-none mb-4"
                          color="primary" 
                          size="x-large"
                          variant="flat"
                          block
                          @click="addEmail"
                      >
                          Add
                      </v-btn>
                     
                      <v-text-field
                          v-if="needEmail"
                          v-model="verificationCode" 
                          label="Enter verification code"
                          variant="outlined"
                          single-line
                          type="text" 
                          required 
                          maxlength="6"
                      ></v-text-field>

                      <v-btn
                          v-if="needEmail"
                          :disabled="loading"
                          :loading="loading"
                          class="text-none mb-4"
                          color="primary" 
                          size="x-large"
                          variant="flat"
                          block
                          @click="submitVerificationCode"
                      >
                          Verify and continue
                      </v-btn>
                  </v-card-text>
              </v-card>
              
          </v-dialog>

          <v-card-actions>
            <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <!-- Bouton avec une couleur dynamique -->
      <v-btn
        :color="isVerified ? 'primary' : 'grey'"
        class="mr-5"
        @click="verifyAndContinue"
        v-bind="attrs"
        v-on="on"
      >
        Continue
      </v-btn>
    </template>

    <!-- Message du tooltip -->
    <span v-if="!isVerified">Your email is not verified</span>
    <span v-else>Your email is verified</span>
  </v-tooltip>
</v-card-actions>
      </v-card> 




<img src="/Group 220.png" alt="Illustration étape 1" class="push-down">

  </v-container>
</template>

<script>
import axios from 'axios';
import { ref, watch } from 'vue';
import 'animate.css'
import 'vuetify/dist/vuetify.min.css';
import { VTooltip } from 'v-tooltip'
export default {
  data() {
    return {
      verificationCode: "", 
      isEmailAdded: false,
      email: "", // Adresse email saisie
      otp: "", // OTP saisi
      otpSent: false, // Indique si l'OTP a été envoyé
      needEmail: false,
      message: "", // Message de retour (succès ou erreur)
      messageType: "error", // Type de message : success / error
      dialog: false, 
      isLoading: false,
      isLoadingAdd: false, 
      userProfile: null, // Stocke la réponse de l'API
      isVerified: false, // Suivi du statut de vérification
      errorMessage: null, // Stocke les messages d'erreur
      loading: false, // Indique l'état de chargement 

    };
;
  },
  methods: {
    validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Vérifie le format de l'email
  return emailRegex.test(email);
},
async submitVerificationCode() {

if (!this.validateEmail(this.email)) {
  this.$store.commit('setSnackBarMessage', "Your email is not valid.");
  this.$store.commit('setSnackBarColor', "error");
  this.$store.commit('activateSnackBar', true);
  return;
}

this.message = "";
this.isLoading = true; 

try {

  const response = await axios.post('/api/v1/savings/code/', {
    verification_code: this.verificationCode, 
  }); 


  this.$store.commit('setSnackBarMessage', response.data.success || "Verification successful!");
  this.$store.commit('setSnackBarColor', "teal darken-4");
  this.$store.commit('activateSnackBar', true);


  if (this.email) {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
      this.dialog = false; 
      this.$emit("emailAdded", this.email);
      window.location.reload(); 
    }, 2000);
  }
 
} catch (error) {

  const errorMessage = error.response?.data?.error || "Error while sending the code.";
  this.$store.commit('setSnackBarMessage', errorMessage);
  this.$store.commit('setSnackBarColor', "error");
  this.$store.commit('activateSnackBar', true);
} finally {
  this.isLoading = false; 
}
},



// Ajouter l'email de l'utilisateur
async addEmail() {
  this.message = "";
  this.isLoadingAdd = true;
  try {
    await axios.post('/api/v1/savings/add-email/', { email: this.email });
    this.$store.dispatch('updateEmail', this.email);
    this.needEmail = true;
  } catch (error) {
    this.message = error.response?.data?.error || "Error while adding the email.";
    this.messageType = "error";
  } finally {
    this.isLoadingAdd = true;
  }
},



    resetForm() {
      this.email = "";
      this.otp = "";
      this.otpSent = false;
      this.needEmail = false;
      this.message = "";
      this.messageType = "error";
    },
    async fetchUserProfile() {
      this.loading = true;
      this.errorMessage = null;

      try {
        const response = await axios.get('/api/v1/savings/user-profile/');
        this.userProfile = response.data;
        this.isVerified = this.userProfile.isVerified; 
        this.$store.dispatch('updateVerificationStatus', this.userProfile.isVerified);
      } catch (error) {
        this.errorMessage =
          error.response?.data?.error || 'Une erreur s\'est produite lors de la récupération du profil.';
      } finally {
        this.loading = false;
      }
    },
    verifyAndContinue() {
      if (this.isVerified) {
        this.$router.push('/Njangi/withdrawals/Check_otp_njangi');
        this.$store.dispatch('updateVerificationStatus', true);

      } else {
        
      }
    },
  },
  mounted() {
    this.fetchUserProfile(); 
  },
};
</script>

<style scoped>

.text-success { color: #1976D2; }
.text-error { color: red; }

.mr-5 {
  margin-left:293px; /* Ajoute un espace à droite */
  weight: 250px;
  height:40px;
}

.push-down
{
  height: 690px;
  weight: 60px;
  margin-top: 0; 
  margin-left: 10px;
}
@media (max-width: 600px) {
  .push-down
{
    height: 400px; /* Réduire la hauteur sur les petits écrans */
    width: 100%;   /* Faire en sorte que la largeur prenne 100% de la largeur de l'écran */
    margin-top: 0; /* Réduire l'espace au-dessus */
    margin-left: 0px;
  }
  .mr-5 {
    
    margin-left:120px; /* Supprime l'espace à droite sur les petits écrans */
  }
}

.v-card-actions > .v-btn {
  margin-right: 16px; /* Ajoute un espace entre chaque bouton */
}

.v-card-actions > .v-btn:last-child {
  margin-right: 0; /* Supprime la marge pour le dernier bouton */
}

.responsive-spacing {
  margin-left: 350px;
}

 @media (max-width: 600px) {

    .responsive-spacing {
      margin-left: 20px;
    }
  }


  .no-underline {
    text-decoration: none; /* Supprime le soulignement */
  }

  .bold {
    font-weight: bold; /* Rend le texte en gras */
  }

  .no-underline:hover {
    text-decoration: none; /* Supprime le soulignement au survol */
  }

  .logo {
    margin-left: 10px; /* Ajoute un espace à gauche du logo */
    height: 40px;
    weight: 40px;
  }

.py-5 {
    font-weight: bold; /* Rend le texte en gras */
    weight: 700px;
  }

  h1 {
            font-size: 14px; /* Taille de la police pour le h1 */
         
            margin-left: 10px;
            margin-top:10px;
            font-weight: 400;
        }
        h2 {
            font-size: 14px; /* Taille de la police pour le h2 */
            
            margin-left: 10px; 
            font-weight: 400;
           
        }
        h3{
            font-size: 14px; /* Taille de la police pour le h2 */
            
            margin-left: 10px; 
            margin-top:20px;
           margin-right: 10px;
           font-weight: 400;
        }




        form {
  margin-bottom: 1em;
}
label {
  display: block;
  margin-bottom: 0.5em;
}
input {
  padding: 0.5em;
  margin-bottom: 1em;
  width: 100%;
  max-width: 400px;
}
button {
  padding: 0.5em 1em;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
}
button:hover {
  background-color: #0056b3;
}
p {
  color: green;
  font-weight: bold;
}
</style>
